export const English = {

    "Dashboard": {
        "Titles": {
            "Ward_Name": "Ward Name",
            "Work_Assigned_by_Officials": "Work Assigned by Officials ",
            "Garden_Daily_Work": "Garden Daily Work",
            "Horticulture_Work_Assigned_by_Officials": "Horticulture Work Assigned by Officials",
            "Civil_Work_Assigned_By_Officials": "Civil Work Assigned By Officials",
            "Electrical_Work_Assigned_By_Officials": "Electrical Work Assigned By Officials",
            "Sports_works": "Sports Work Assigned By Officials",
            "Work_Progress_By_Contractor": "Work Progress By Contractor",
            "Horticulture_Work_Progress_By_Contractor": "Horticulture Work Progress",
            "Civil_Work_Progress_By_Contractor": "Civil Work Progress",
            "Electrical_Work_Progress_By_Contractor": "Electrical Work Progress",
            "Sports_works_Progress": "Sports Work Progress",
            "Assigned_work": "Assigned work",
            "Pending": "Pending",
            "Completed": "Completed",
            "Work_Reopen_Progress_By_Contractor": "Work Reopen Progress By Contractor",
            "Horticulture_work_reopen_progress": "Horticulture Work Reopen Progress By Contractor",
            "Reopened_Work": "Reopened Work",
            "Civil_Work_Reopen_Progress_By_Contractor": "Civil Work Reopen Progress By Contractor",
            "Electrical_Work_Reopen_Progress_By_Contractor": "Electrical Work Reopen Progress By Contractor",
            "Master_Data": "Master Data",
            "Sports_works_Reopen_By_Contractor": "Sports Works Reopen By Contractor",
            "Schedule_Date": "Schedule Date",
            "Attendance": "Attendance",
            "Assigned_Work_Completed": "Assigned Work Completed Garden",
            "Work_Completed": " Work Completed Garden",
            "Road_Divider": 'Road Divider',



        },

        "Pcmc_Assets": {
            "Pcmc_Assets": "PCMC Assets",
            "Ward_no": "Ward no",
            "Sector_Name": "Sector Name",
            "Maintain_By": "Maintain By",
            "Sr_No": "Sr.No",
            "Area_Name": "Area Name",
            "Garden_Name": "Garden Name",
            "Allocation_checklist": "Allocation checklist",
            "Pending_checklist": "Pending checklist",
            "Completed_checklist": "Complete checklist",
            "Image": "Image",
            "Track": "Track",
            "Action": "Action",
            "Asset_Type": "Asset Type",
            "Asset_Name": "Asset Name",
            "Area_Name": "Area Name",
            "Area": "Area (in Hector)",
            "Area_sq": "Area (in Sq.Meter)",
            "Status": "Status ",
            "Road_Divider_Name": "Road Divider Name",
            "Open_Space": "Open Space",
            "Tree_Belt_Name": "Tree Belt's Name",
            "chowks_Name": "Chowks Name",
            "chowks_master": "Chowks ",
            "Tree_Belt’s_master": 'Tree Belt’s',
            "Play_Equipments": 'Play Equipments',
            "Open_Space_master": "Open Space",
            "Road_Divider": "Road Divider",
            "Garden_Master": "Garden Master",
            "Zone_Name": "Zone Name",
            "Equipment_Name": "Equipment Name",
            "Supplier_Name": "Contractor Name",
            "Area_Square_meter": "Area (in Meter)"
        },
        "Work_Assigned_by_Officials": {
            "From_Date": "From Date",
            "To_Date": "To Date",
            "Contractor_Name": "Contractor Name",
            "Assign_Date": "Assign Date",
            "Area1": "Area",
            "Work_Name": "Work Name",
            "Assign_Work_Photo": "Assign Work Photo",
            "Officer_Name": "Officer Name",
            "Assign_Contractor_Name": "Assign Contractor Name",
            "Assigned_By": "Assigned By",
            "Completed_Work_Date": "Completed Work Date",
            "Completed_Work_Photo": "Completed Work Photo",
            "BenchMark": "BenchMark",
            "Reopened_By": "Reopened By",
            "Reopened_Photo": "Reopened Work Photo",
            "Work_Date": "Work Date"
        }
    },
    "Sidebar": {
        "Dashboard": "Dashboard",
        "Preventive_Work_Report": "Penalty Report",
        "Completed_Work_Report": "Completed Work Report",
        "Garden_Report": "Garden Reports",
        "Employee_Tracking": "Employee Tracking",
        "Work_Type": "Work Type",
        "Upload_Date": "Upload Date",
        "Work_Assign_By": "Work Assign By",
        "Asset_Type": "Asset Type",
        "Work_Done_Date": "Work Done Date",
        "Before_Work_Photo": "Before Work Photo",
        "After_Work_Photo": "After Work Photo",
        "Role": "Role",
        "Daily_Work_Sheet": 'Daily Attendance Sheet',
    },


    "AdminDashboard": {
        "Admin_Titles": {
            "Daily_Preventive_Work": "Daily Preventive Work",
            "Work_Progress_by_Contractors": "Work Progress by Contractors",
            "Reopen_Work_Progress": "Reopen Work Progress",
            "Deputy_Municipal_Commissioner_(DMC)": "Deputy Municipal Commissioner (DMC)",
            "Garden_Officer_(GO / AGO)": "Garden Officer (GO / AGO)",
            "Garden_Assistant_(GA)": "Garden Assistant (GA)",
            "Garden_Supervisor_(GS)": "Garden Supervisor (GS)",
            "Reopen_Pending": "Reopen Pending",
            "Reopen_Completed": "Reopen Completed",


            "Total_Work": 'Total Work',
            'Total_works_Completed': 'Total Completed Work',
            "Pending_Work": 'Pending Work',
            'Daily_Work_Completed': 'Daily Work Completed',
            'Daily_Work_Pending': 'Daily Work Pending',
            'Remark': 'Remark'
        },

        "Grid_Heading": {
            "Daily_Preventive_Work_Pending": "Daily Preventive Work Pending",
            "Daily_Preventive_Work_Completed": "Daily Preventive Work Completed",
            "WORK_ASSIGNED": "WORK ASSIGNED",
            "WORK_ASSIGNED_Deputy_Municipal_Commissioner_(DMC)": "WORK ASSIGNED / Deputy Municipal Commissioner (DMC)",
            "WORK_ASSIGNED_Garden_Officer_(GO / AGO)": "WORK ASSIGNED / Garden Officer (GO / AGO)",
            "WORK_ASSIGNED_Garden_Assistant_(GA)": "WORK ASSIGNED / Garden Assistant (GA)",
            "WORK_ASSIGNED_Garden_Supervisor_(GS)": "WORK ASSIGNED / Garden Supervisor (GS)",
            "Reopen_Work_Progress_Reopen_Pending": "Reopen Work Progress Reopen Pending",
            "Reopen_Work_Progress_Reopen_Completed": "Reopen Work Progress Reopen Completed",
        },

        "Table_Heading": {
            "Date": "Date",
            "Day": "Day",
            "Work_Sub_Type": "Work Sub Type",
            "Reopen_Date": "Reopen Date",
            "Reopen_Work_Photo": "Reopen Work Photo",
            "Work_Reopen_Date": "Work Reopen Date",
            "Reopen_Completed_Work_Date": "Reopen Completed Work Date",
            "Reopen_Completed_Work_Photo": "Reopen Completed Work Photo",
        },

        "Admin_Sidebar_Name": {
            "Master": "Master",
            "Garden_Reports": "Garden Reports",
            "Designation": "Designation",
            "Employee": "Employee",
            "User_Creation": "User Creation",
            "Ward_Master": "Ward Master",
            "Sector_Master": "Sector Master",
            "Work": "Work",
            "Work_Sub_Type": "Work Sub Type",
            "Project_Name": "Project Name",
            "Contractor_Wise_Assets": "Contractor Wise Assets",
            "Project_Wise_Contractor": "Project Wise Contractor",
            "Project_Wise_Work_Name": "Project Wise Work Name",
            "Garden_wise_maintenance_status": "Garden wise maintenance status",
            "User_Wise_Ward_Mapping": "User Wise Ward Mapping"
        },

        "Admin_Sidebar_Grid_Heading": {
            "Designation_Master": "Designation Master",
            "Employee_Master": "Employee Master",
            "User_Creation_Master": "User Creation Master",
            "Contractor_Name_Master": "Contractor Name Master",
            "Zone_Master": "Zone Master",
            "Sector_Garden_Master": "Sector Garden Master",
            "Work_Type_Garden_Master": "Work Type Garden Master",
            "Work_Sub_Type_Garden_Master": "Work Sub Type Garden Master",
            "Work_Garden_Master": "Work Garden Master",
            "Project_Name_Master": "Project Name Master",
            "Project_Wise_Contractor_Master": "Project Wise Contractor Master",
            "Project_Wise_Work_Name_Master": "Project Wise Work Name Master",
        },

        "Admin_Sidebar_Table_Heading": {
            "Designation_Name": "Designation Name",
            "Mobile_Number": "Mobile Number",
            "Email_Id": "Email Id",
            "Table_User_Name": "Table User Name",
            "User_Name": "User Name",
            "Password": "Password",
            "Address": "Address",
            "Contact_Person_Name": "Contact Person Name",
            "Zone_Name": "Zone Name",
            "Prabhag_No": "Prabhag No",
            "Benchmark_in_Days": "Benchmark in Days",
            "Penalty_Amount_(Rs.)": "Penalty Amount (Rs.)",
            "Project_Type": "Project Type",
            "User": "User",
            "Equipment_No.": "Equipment No.",
            "Equipment_Installation_Date": 'Equipment Installation Date',
            "Visited_Date": 'Visited Date',
            "Work_Description": 'Work Description',
            "Department": 'Department',
            "Photo": 'Photo',
            "Work_Photo": "Work Photo",
            "After_Work_Photo": 'After Work Photo',
            "Before_Work_Photo": 'Before Work Photo',
            "Total_Gardens" : "Total Gardens" 

        },
    },
    "EmployeeAndContractor": {
        "Officer_Name_Pending_Work_Status": "Officers Pending Work Status",
        "Contractor_Name_Pending_Work_Status": 'Contractors Pending Work Status',
        "Total_Assign_Works": "Total Assign Works",
        "Total_works_Completed": "Total works Completed",
        "Total_Pending_Works": "Total pending works",
        "Total": 'Total',
        "0_to_7_days": "0 to 7 days",
        "7_to_15_days": "7 to 15 days",
        "15_to_30_days": "15 to 30 days",
        "30_to_90_days": "30 to 90  days",
        "90_to_180_days": "90 to 180 days",
        "1_year": "1 year",
        "Karmachari": 'Officer',
        'Thekedar': 'Contractor',
        'Karmachariche_Nav': 'Officer Name',
        'Thekedaryache_Nav': 'Contractor Name',
        'Daily_Work': 'Daily Preventive Work',
        'Yes': 'Yes',
        'No': 'No',
        'Count': 'Count',
        'ChecklistPhoto': 'Checklist Photo',
        'Checklist': 'Checklist',
        'ChecklistName': 'Checklist Name',
        'VisitTarget': 'Visit Target',
        'Achievement': 'Achievement',
        'Pending': 'Pending'

    },

    // ----------Education Translation ---------

    "Educationdashboard": {
        "dashboard": {
            "Primary_school": "Primary School",
            "Secondary_school": "Secondary School",
            "Daily_Work": "Daily Work",

        }
    },


    // ----------Education Translation ---------

    "Healthdashboard": {
        "dashboard": {
            "Daily_Work": "Daily Work",
            "Manpa_school": "Manapa school",
            "Mukhya_Karyalay": "Head Office",
            "Kshetriy_Karyalay": "Regional Office",
            "Sarvjanik_Swachhatagruhe": "Public Toilets",
            "Smashan_Bhumi": "Cemetery",

        }
    },
    "EncroachmentDashboard": {
        Year: "Year",
        Month: 'Month',
        Zone: "Zone",
        Dashboard: 'Dashboard',
        // Received Complaints - Social media & Officer Visit
        UploadComplaintsSocialmediaandOfficerVisit: 'Complaints Received By Yourself',
        ComplaintStatusfromofficials: 'Complaint Status From Officials',

        // Dashboard start  

        Encromchment: 'Encroachment',
        IllegalConstrcation: 'Illegal Construction',
        EncroachmentIllegalConstruction: 'Encroachment & Illegal Construction',
        Uploadcomplaint: 'Upload Complaint',
        // UploadComplaintDate: 'Upload Complaint Date',
        UploadComplaintDate: 'Complaint Upload Date',
        UploadDate: "Upload Date",
        ZoneName: 'Zone Name',
        VehicleStartPlace: 'Vehicle Start Place',
        UploadComplaintPhoto: 'Upload Complaint Photo',
        FromDate: 'From Date',
        ToDate: 'To Date',
        View: 'View',
        SelfAssigned: 'Self-Assigned',
        ForwardComplaints: 'Forward Complaints',
        ReceivedComplaint: 'Received Complaint',
        AcknowledgedComplaint: 'Acknowledged Complaint',
        ForwardComplaint: 'Forward Complaint',
        ScheduleComplaint: 'Schedule Complaint',
        ClosedComplaint: `Closed Complaint`,
        PendingComplaint: 'Pending Complaint',
        TodaysTotalComplate: 'Today’s Complaint',
        TodaysClosedComplaint: 'Today’s Closed Complaint',
        CreateScheduling: 'Create Scheduling',
        TotalScheduling: 'Total Scheduling',
        UpcomingScheduling: 'Upcoming Scheduling',
        CompletedScheduling: 'Completed Scheduling',
        ComplaintReceivedDate: 'Complaint Received Date',
        ComplaintUploadDate: 'Complaint Upload Date',
        UploadPhoto: 'Upload Photo',
        ForwardedComplaints: 'Forward Complaints',
        complaintsentofficername: 'Complaint Sent Officer Name',
        Forward: 'Forward',
        Remark: 'Remark',
        complaintUploadedOfficername: 'Complaint Uploaded Officer Name',
        Acknowledge: 'Acknowledge',
        AcknowledgedDate: 'Acknowledged Date',
        Forwarddate: 'Complaint Forward Date',
        complaintReceivedOfficerName: 'complaint Received Officer Name',
        ComplaintScheduleDate: 'Complaint Schedule date',
        ComplaintCloseDate: 'Complaint Close Date',
        CompletedPhoto: 'Completed Photo',
        Track: 'Track',
        OfficerName: 'Officer Name',
        date: 'Date',
        Intime: 'In time',
        OutTime: 'Out Time',
        TotalHrs: 'Total Hrs',
        ShiftTime: 'Shift ',
        INPhoto: "In Photo",
        OutPhoto: "Out Photo",
        PresentEmployee: 'Present Employee',
        AbsentEmployee: 'Absent Employee',
        // Reportscheduleddate: 'Report Scheduled Date',
        ScheduledCreateDate: 'Scheduled Create Date',
        ScheduleDate: 'Schedule Date',
        Pathakname: 'Pathak Name',
        Shift: 'Shift',
        WorkTime: 'Work Time',
        workArea: 'Work Area',
        ScheduleReportPdf: 'Schedule Report(Pdf)',
        Open: 'Open',
        Ward: 'Ward',
        Day: 'Day',
        Photo: 'Photo',
        Present: 'Present',
        Absent: 'Absent',
        EncroachmentandIllegalConstructionWebandMobileBased: 'Encroachment & Illegal Construction',
        Area: 'Area',
        ScheduleDetails: 'Schedule Details',
        ScheduleDay: 'Schedule Day',
        pathakNocode: 'Pathak No/Code',
        WorkTimefrom: 'Work Time From',
        workTimeTo: 'work Time To',
        GroupAttendance: 'Group Attendance',
        PendingSiteVisits: 'Pending Site Visits',
        SarthiPortal: 'Sarthi Portal',
        SocialMedia: 'Social Media',
        OfficerVisit: "Officer Visit",
        Team: "Team",
        Pathak: 'Pathak',
        CompletedDate: "Completed Date",
        CompletedDay: "Completed Day",
        EncroachmentWard: "Encroachment Ward ",
        EncroachmentArea: "Encroachment Area ",
        UploadedThrough: "Uploaded Through ",
        FromOfficerName: "From Officer Name",
        FromStatus: "From Status ",
        ToOfficerName: "To officer Name ",
        ToStatus: "To Status",
        CreateByOfficerName: "Created by Officer Name",
        NameofForwardedOfficer : "Name of Forwarded Officer",


        // master
        DepartmentMaster: 'Department Master',
        DepartmentName: 'Department Name',
        SrNo: 'Sr. No.',
        Action: 'Action',
        Master: 'Master',
        DepartmentMaster: 'Department Master',
        RoleMaster: 'Role Master',
        DesignationMaster: 'Designation Master ',
        DesignationName: 'Designation Name ',
        EmployeeMaster: 'Employee Master',
        UserCreation: 'User Creation',
        ZoneMaster: 'Zone Master',
        WardMaster: 'Ward Master',
        ItemMaster: 'Item Master',
        WorkTypeMaster: 'Work Type Master',
        WorkMaster: 'Work Master',
        VehicleMaster: 'Vehicle Master',
        ZoneWiseVehicleMapping: 'Zone Wise Vehicle Mapping',
        ZoneWiseAreaMaster: 'Zone Wise Area Master',
        ZoneWiseArea: 'ZoneWiseArea',
        PathakMaster: 'Pathak Master',
        PathakWiseEmployee: 'Pathak Wise Employee',
        ZoneName: 'Zone Name',
        EmployeeName: 'Employee Name',
        Actions: ' Action',
        AreaName: 'Area Name',
        EmailID: 'Email ID',
        Gender: ' Gender',
        ItemName: 'Item Name',
        JoiningDate: 'Joining Date',
        MobileNumber: 'Mobile Number',
        Password: ' Password',
        Username: 'Username',
        Role: ' Role',
        PathakName: 'Pathak Name',
        Status: ' Status',
        VehicleModule: ' Vehicle Module',
        VehicleName: ' Vehicle Name',
        VehicleNumber: ' Vehicle Number',
        WardName: ' Ward',
        WorkName: ' Work Name',
        WorkTypeName: ' Work Type Name',
        Status: ' Status',
        Select: 'Select...',
        Total: 'Total',
        ZoneA: 'Zone-A',
        ZoneB: 'Zone-B',
        ZoneC: 'Zone-C',
        ZoneD: 'Zone-D',
        ZoneE: 'Zone-E',
        ZoneF: 'Zone-F',
        ZoneG: 'Zone-G',
        ZoneH: 'Zone-H',
        JoiningDate: 'Joining Date',
        OrderDate: 'Order Date',
        OrderDay: 'Order Day',
        OrderNumber: 'Order Number',
        ScheduleDate: 'Schedule Date',
        ScheduleDay: 'Schedule Day',
        ShiftTiming: 'Shift Time',
        ScheduleOrder: 'Schedule Order',
        ActionReport: 'Action Report',
        OrderNumber: 'Order Number',
        Schedule: 'Schedule',
        Report: 'Report',
        UserWiseMapping: 'User Wise Mapping',
        EmployeeCount : "Employee Count",

        // Illegal Constrcation

        SiteVisits: 'Site Visits',
        SiteVerification: 'Site Verification',
        IssueNotice: 'Issue Notice',
        UploadedComplaint: 'Uploaded Complaint',
        SiteVisitDate: 'Site Visit Date',
        SiteVisitPhoto: 'Site Visit Photo',
        SiteVisitVideo: 'Site Visit Video',
        SiteVerificationDate: 'Site Verification Date',
        UploadedBy: 'Uploaded By',
        SiteVerificationPhoto: 'Site Verification Photo',
        CompletedPhoto: 'Completed Photo',
        ComplaintuploadPhoto: 'Complaint upload Photo',
        Notice: 'Notice',
        ComplaintForwardDate: 'Complaint Forward Date',
        SiteVisitDetails: 'Site Visit Details',
        ComplaintPhoto: 'Complaint Photo',
        Doyouwanttoclosethecomplaint: 'Do you want to close the complaint?',
        GroupAttendancetime: 'Group Attendance Time',
        Selfattendance: 'Self-Attendance',
        EmployeeAttendance: 'Employee Attendance',
        DailyComplaint: 'Daily Complaint',
        ViewScheduling: 'View Scheduling',
        AddComplainttoScheduling: 'Add Complaint to Scheduling',
        ViewVehicleScheduling: 'View Vehicle Scheduling',
        TodaysScheduling: 'Today’s Scheduling',
        TodaysAction: 'Today’s Completed Scheduling',
        PendingScheduling: 'Pending Scheduling',

        FirstShift: '1 st Shift',
        SeconsShift: '2 nd Shift',
        VehicleTracking: 'Vehicle Tracking',
        SiteVisit: 'Site Visit',
        UnrelatedComplaints: 'Unrelated Complaints',
        PendingSiteVerification: 'Pending Site Verification',
        DemollitionComplaint: 'Demolition Complaint',
        PastScheduling: 'Past Scheduling',
        BeforeWorkPhoto: 'Before Work Photo',
        AfterWorkPhoto: 'After Work Photo',
        BeforePhoto: 'Before Photo',
        AfterPhoto: 'After Photo',
        ComplaintTrack: 'Complaint Track',
        ComplaintActionReport: 'Complaint Action Report',
        ReceivedComplaints: 'Received Complaints',
        NoticeIssue: 'Notice Issue',
        SiteVerification: 'Site Verification',
        PendingSiteVerification: 'Pending Site Verification',
        SingedNotice: 'Singed Notice',
        ActionTaken: 'Action Taken',
        Approvedby: 'Approved by',
        ConstructionType: 'Construction Type',
        SiteVerificationOfficerName: 'Site Verification Officer Name',
        OwnerDetails: 'Owner Details',
        Village: 'Village',
        location: 'Location',
        TotalArea: 'Total Area',
        ShowNotice: 'Notice',
        ConstructionBoundaries: 'Construction Boundaries',
        ConstructionBoundariesName: 'Construction Boundaries Name',
        Video: 'Video',
        East: 'East',
        West: 'West',
        South: 'South',
        North: 'North',
        Verifiednotices: 'Verified Notices',
        legalSite: 'Legal Site',
        CourtCases: 'Court Cases',
        SiteVisitComplaintsReceived: 'Site Visit Complaints Received',
        SiteVisitedComplaints: 'Site Visited Complaints',
        NoticeIssueComplaints: 'Notice Issue Complaints',
        ViewSignedNotice: 'View Signed Notice',
        SiteVerificationDetails: 'Site Verification Details',
        ConstructionBoundariesDetails: 'Construction Boundaries Details',
        UploadComplaintDetails: 'Upload Complaint Details',
        IssueNoticeDate: 'Issue Notice Date',
        SiteOfficerVerificationName: 'Site Officer Verification Name',
        Clause: 'Clause',
        Notice: 'Notice',
        SiteVerificationReamrk: 'Site Verification Remark',
        CourtNotice: 'Court Notice',
        SurveyNo: 'Survey No',
        Nameoftheofficerissuingthenotice: 'Name of the officer issuing the notice',
        NoticePeriod: 'Notice Period',
        NoticeNo: 'Notice No.',
        NoticeVerified: 'Notice Verified',
        ServeNotice: 'Serve Notice',
        Return: 'Return',
        SizedItemDetails: 'Seized Item Details',
        SeizedItemList: 'Seized Item List',
        OwnerDetails: 'Owner Details',
        ItemList: 'Item List',
        Count: 'Count',
        Doyouwanttoreturnthecomplaint: 'Do you want to return the complaint?',
        Select: 'Select...',


    },
        
    
}